import GetToken from './GetToken';

export default GetToken;
